angular.module('myApp.directives')
    .directive('thumbUpDown', function () {
        return {
            restrict: 'A',
            scope: true,
            link: function (scope, element, attrs) {
            },
            controller: function ($scope, $element, $attrs, $transclude) {
                var input           = $element.find('input');
                var upBtn           = $element.find('.thumbUp');
                var downBtn         = $element.find('.thumbDown');
                var parentDiv       = $element.parents("div").get(0);
                var textarea        = $(parentDiv).find("textarea");
                var disableClass    = 'grey_btn';
                textarea.hide();

                upBtn.off('click').on('click', function () {
                    makeUpDown(true, function() {
                        upBtn.removeClass(disableClass);
                        downBtn.addClass(disableClass);
                        textarea.show();
                    });
                });
                downBtn.off('click').on('click', function () {
                    makeUpDown(false, function() {
                        upBtn.addClass(disableClass);
                        downBtn.removeClass(disableClass);
                        textarea.show();
                    });
                });
                var makeUpDown = function(isUp, callback) {
                    if (input.length) {
                        isUp = !!isUp;
                        input.val(isUp ? "1" : "0");
                        if (callback) {
                            callback();
                        }
                        if ('setDefaultResponseType' in $scope) {
                            $scope.setDefaultResponseType();
                        }
                    }
                };
            }
        }
    });